import styled from 'styled-components';
import { FormInputIcon } from '@spotify-internal/encore-web';

export const SearchFormInputIcon = styled(FormInputIcon)`
  svg {
    left: 7px;
  }
`;
